<template>
  <div id="commodity">
    <div class="header flex-between">
      <div class="header-text">
        <h1>积分商城商品管理</h1>
      </div>

      <div class="header-button">
        <el-button v-if="jurisdiction.search"
                   icon="el-icon-search"
                   plain
                   @click="Searchbtn">查询</el-button>
        <el-button v-if="jurisdiction.create"
                   icon="el-icon-circle-plus-outline"
                   plain
                   @click="createVisible = true">创建</el-button>
        <el-button v-if="jurisdiction.copy"
                   icon="el-icon-circle-plus-outline"
                   plain
                   @click="CopeyGiftmution">复制</el-button>
        <el-button v-if="jurisdiction.shelves"
                   icon="el-icon-sell"
                   plain
                   @click="Shelvesbtn">上下架</el-button>
        <el-button v-if="jurisdiction.modify"
                   icon="el-icon-edit-outline"
                   plain
                   @click="Modifywacth">修改</el-button>
        <el-button v-if="jurisdiction.delete"
                   icon="el-icon-delete"
                   plain
                   @click="DeleteBtn">删除</el-button>
        <el-button v-if="jurisdiction.look"
                   icon="iconfont icon-chakan1"
                   plain
                   @click="Viewthedata">查看</el-button>
      </div>
    </div>
    <!-- 创建-选择类型弹窗 -->
    <div class="create">
      <el-dialog width="20%"
                 title="积分商城商品管理-创建-选择类型弹窗"
                 :visible.sync="createVisible">
        <div style="text-align: center; margin-top: 30px">
          <el-button @click="goToControl">礼券</el-button>
          <el-button @click="goToGiftCreates">礼品</el-button>
          <el-button @click="goToVoucherCreates">券包</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- tab表格中心数据 -->
    <div class="no-card">
      <el-card shadow="never">
        <div>
          <el-form label-width="100px"
                   :model="formLabelAlign"
                   size="mini">
            <el-row :gutter="50">
              <el-col :span="8">
                <el-form-item :inline="true"
                              label="商品名称">
                  <el-input v-model="formLabelAlign.commodityName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="商品类型">
                  <el-select style="width: 100%"
                             v-model="formLabelAlign.commKind">
                    <el-option label="全部"
                               value=""></el-option>
                    <el-option label="礼券"
                               value="0"></el-option>
                    <el-option label="礼品"
                               value="1"></el-option>
                    <el-option label="券包"
                               value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select style="width: 100%"
                             v-model="formLabelAlign.state">
                    <el-option label="全部"
                               value=""></el-option>
                    <el-option label="已上架"
                               value="0"></el-option>
                    <el-option label="未上架"
                               value="1"></el-option>
                    <el-option label="已下架"
                               value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-col :span="8">
              <el-form-item label="创建日期从">
                <el-date-picker v-model="formLabelAlign.createStartDay"
                                type="date"
                                placeholder="开始日期"
                                value-format="yyyy-MM-dd"
                                style="width: 92%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="至">
                <!-- <el-input v-model="formLabelAlign.region"></el-input> -->
                <el-date-picker v-model="formLabelAlign.createEndDay"
                                type="date"
                                placeholder="结束日期"
                                style="width: 93%; margin-left: 15px"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-col>

          </el-form>
        </div>
      </el-card>
    </div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <el-table size="small"
                  class="table-style"
                  border
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
                  :cell-style="{ 'text-align': 'center' }"
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  v-loading="loading"
                  v-el-table-infinite-scroll="load"
                  infinite-scroll-disabled="onLoading">
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio v-model="radioId"
                        :label="scope.$index"
                        @change.native="handleRadioChange(scope.row)">&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="commodityName"
                           label="商品名称">
            <template scope="scope">
              <div v-if="jurisdiction.modify"
                   style="text-decoration: underline; color: #76734f"
                   @click="handleGoods(scope.row)">
                {{ scope.row.commodityName }}
              </div>
              <div v-else
                   style="text-decoration: underline; color: #76734f">
                {{ scope.row.commodityName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="commKind"
                           label="类型">
            <template slot-scope="scope">
              {{
                scope.row.commKind === 0
                  ? "礼券"
                  : "" || scope.row.commKind === 1
                  ? "礼品"
                  : "" || scope.row.commKind === 2
                  ? "券包"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="state"
                           label="状态">
            <template slot-scope="scope">
              {{
                scope.row.state == 0
                  ? "已上架"
                  : scope.row.state == 1
                  ? "未上架"
                  : scope.row.state == 2
                  ? "已下架"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="stockQty"
                           label="库存"> </el-table-column>
          <el-table-column prop="redeemedQty"
                           label="已兑换数量">
          </el-table-column>
          <el-table-column prop="creditPoint"
                           label="兑换积分">
          </el-table-column>
          <el-table-column prop="startDate"
                           label="兑换开始日期">
            <template scope="scope">
              {{ scope.row.startDate | dateFormats }}
            </template>
          </el-table-column>
          <el-table-column prop="endDate"
                           label="兑换结束日期">
            <template scope="scope">
              {{ scope.row.endDate | dateFormats }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName"
                           label="创建人">
          </el-table-column>
          <el-table-column prop="createTimeStr"
                           label="创建日期">
            <template scope="scope">
              {{ scope.row.createTimeStr | dateFormats }}
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName"
                           label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTimeStr"
                           label="最后修改日期">
            <template scope="scope">
              {{ scope.row.updateTimeStr | dateFormats }}
            </template>
          </el-table-column>
        </el-table>
        <el-alert v-if="isMore"
                  title="没有更多数据了!"
                  type="warning"
                  center
                  :closable="false">
        </el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  commodityApi,
  commoditydelete,
  upperOrLowerApi,
} from "@/api/Integralquery";
export default {
  name: "centre",
  data () {
    return {
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        shelves: false,
        modify: false,
        delete: false,
        look: false,
      },
      radioId: "",
      //存放选中的radio值
      handleRadioValue: [],
      // 创建-选择类型弹窗
      createVisible: false,
      // 修改-选择类型弹窗
      amendVisible: false,
      // 修改-选择类型弹窗
      lookVisible: false,
      // 修改弹窗
      // reviseVisible: false,
      loading: false, //加载中
      labelPosition2: "top",
      formLabelAlign: {
        pageNo: 1,
        pageSize: 20,
        commKind: "", //商品类型
        commodityName: "", //商品名称
        createEndDay: "", //结束日期
        createStartDay: "", //开始日期
        pages: 0,
        state: "", //状态
      },
      form: {
        name: "",
      },
      tableData: [],
      //存储vuex数据
      storageMax: {},
    };
  },
  created () {
    this.commodityquery();
    let Commodity = JSON.parse(localStorage.getItem("Commodity"));
    for (let i = 0; i < Commodity.length; i++) {
      if (Commodity[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Commodity[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (Commodity[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (Commodity[i].menuName == "上下架") {
        this.jurisdiction.shelves = true;
        continue;
      }
      if (Commodity[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (Commodity[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (Commodity[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  computed: {
    isMore () {
      //当起始页数等于总页数时停止加载
      return this.formLabelAlign.pageNo >= this.formLabelAlign.pages;
    },
    onLoading () {
      return this.loading || this.isMore;
    },
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToControl () {
      this.$router.push("/Control");
    },
    goToGiftCreates () {
      this.$router.push("/GiftCreates");
    },
    goToVoucherCreates () {
      this.$router.push("/VoucherCreates");
    },
    //tab表格主数据表格数据
    async commodityquery () {
      await commodityApi(this.formLabelAlign).then((res) => {
        if (res.message == "success") {
          this.tableData = res.data.list;
          this.formLabelAlign.pages = res.data.pages;
          this.loading = false;

        }
      });
    },
    //查询功能
    Searchbtn () {
      this.commodityquery();
    },
    //中心表格数据滚动加载
    load () {
      this.loading = true;
      setTimeout(() => {
        this.formLabelAlign.pageSize += 10; //页面数据每次10
        this.commodityquery(); //调用接口，此时页面数据+50，获取下一次50数据
      }, 1000);
    },
    //radio选中赋值
    handleRadioChange (val) {
      this.handleRadioValue = val;
      if (val.commKind === 0) {
        this.storageMax = val;
      }
    },
    //选中数据删除
    DeleteBtn () {
      if (Object.keys(this.handleRadioValue).length <= 2) {
        this.$message.warning("请选择要删除的数据");
        return false;
      }
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          commoditydelete({
            commodityID: this.handleRadioValue.commodityID,
          }).then((res) => {
            if (res.success) {
              this.$message.success("删除成功");
              this.radioId = "";
              this.tableData = [];
              this.commodityquery();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("撤销删除");
        });
    },
    //上下架改变状态
    Shelvesbtn () {
      if (Object.keys(this.handleRadioValue).length <= 2) {
        this.$message.warning("请选中要修改的数据!");
        return false;
      }
      let state = 1;
      if (this.handleRadioValue.state == 0) {
        state = 2;
      } else {
        state = 0;
      }
      this.$confirm("确认是否上架或下架？", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          upperOrLowerApi({
            commodityID: this.handleRadioValue.commodityID,
            state: state,
          }).then((res) => {
            if (res.success) {
              this.$message.success("操作成功！");
              this.radioId = "";
              this.tableData = [];
              this.commodityquery();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("撤销操作！");
        });

      // console.log(this.handleRadioValue.state);
    },
    //查看跳转相应页面
    Viewthedata () {
      if (this.handleRadioValue == "") {
        this.$message.warning("请输入要查看的数据！");
      } else if (this.handleRadioValue.commKind === 0) {
        //礼券
        this.$router.push({
          path: "/ViewGift",
          query: {
            certificate: this.handleRadioValue.commodityID,
          },
        });
      } else if (this.handleRadioValue.commKind === 1) {
        //礼物
        this.$router.push({
          path: "/GiftSee",
          query: {
            Gift: this.handleRadioValue.commodityID,
          },
        });
      } else if (this.handleRadioValue.commKind === 2) {
        //券包
        this.$router.push({
          path: "/VoucherView",
          query: {
            wrap: this.handleRadioValue.commodityID,
          },
        });
      }
    },
    //修改跳转
    Modifywacth () {
      if (this.handleRadioValue == "") {
        this.$message.warning("请选择要修改的数据！");
      } else if (this.handleRadioValue.commKind === 0) {
        this.$store.dispatch("user/couponstoview", this.storageMax);
        localStorage.setItem("webpackge", JSON.stringify(this.storageMax));
        this.$router.push({
          path: "/GiftCertificate",
        });
      } else if (this.handleRadioValue.commKind === 1) {
        this.$router.push({
          path: "/GiftModify",
          query: {
            moneyes: this.handleRadioValue.commodityID,
          },
        });
      } else if (this.handleRadioValue.commKind === 2) {
        this.$router.push({
          path: "/VoucherChange",
          query: {
            Gvarch: this.handleRadioValue.commodityID,
          },
        });
      }
    },
    //复制功能
    CopeyGiftmution () {
      if (this.handleRadioValue == "") {
        this.$message.warning("请选中复制的数据！");
      } else if (this.handleRadioValue.commKind === 0) {
        //礼券
        this.$store.dispatch("user/couponstoview", this.storageMax);
        localStorage.setItem("webpackge", JSON.stringify(this.storageMax));
        this.$router.push({
          path: "/copygiftcertificate",
        });
      } else if (this.handleRadioValue.commKind === 1) {
        this.$router.push({
          path: "/copygiftmodify",
          query: {
            moneyes: this.handleRadioValue.commodityID,
          },
        });
      } else if (this.handleRadioValue.commKind === 2) {
        this.$router.push({
          path: "/copyvoucherchange",
          query: {
            Gvarch: this.handleRadioValue.commodityID,
          },
        });
      }
    },
    handleGoods (val) {
      if (val.commKind === 0) {
        //礼券
        this.$router.push({
          path: "/ViewGift",
          query: {
            certificate: val.commodityID,
          },
        });
      } else if (val.commKind === 1) {
        //礼物
        this.$router.push({
          path: "/GiftSee",
          query: {
            Gift: val.commodityID,
          },
        });
      } else if (val.commKind === 2) {
        //券包
        this.$router.push({
          path: "/VoucherView",
          query: {
            wrap: val.commodityID,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#commodity {
  height: 100%;
}
.header {
  .header-text {
    width: 20rem;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }

  // 创建弹窗样式
  .create,
  .amend,
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }
  }
  // 修改弹窗样式
  //   .revise {
  //     .el-dialog__header {
  //       background-color: #f3f1dd;
  //     }
  //     .el-dialog__title {
  //       font-size: 14px;
  //       font-weight: 700;
  //       color: #6c6937;
  //     }
  //     .el-dialog__body {
  //       padding: 0 50px 30px 50px;
  //     }
  //     .el-dialog__footer {
  //       height: 60px;
  //       text-align: center;
  //       background-color: #f2f2f2;
  //     }
  //     .el-button:hover {
  //       background-color: #b5b386;
  //       color: #f2f2f2 !important;
  //     }
  //     .el-form-item {
  //       margin-bottom: 0px !important;
  //     }

  //     .el-input__inner {
  //       height: 30px;
  //     }
  //     .el-form-item__content {
  //       line-height: 0px;
  //     }
  //   }
}
</style>
